interface FormatTemplateParams {
  template: string;
  data: {
    count: string;
  };
}

export function formatTemplate(params: FormatTemplateParams) {
  const { template, data } = params;

  const _template = String(template);

  if (_template.includes('$count') && data.count == null) {
    console.warn('$count is present but `count` variable is missing');
  }

  return _template.replace('$count', data.count);
}
